function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.237 2.255C5.237 1.84 5.574 1.50299 5.989 1.50299H17.012C17.427 1.50299 17.764 1.84 17.764 2.255V22.45H5.237V2.255ZM19.267 22.45V0.750996C19.267 0.335996 18.931 -3.8147e-06 18.515 -3.8147e-06H4.485C4.07 -3.8147e-06 3.733 0.335996 3.733 0.750996V22.45H0.3C0.134 22.45 0 22.584 0 22.75V23.654C0 23.819 0.134 23.954 0.3 23.954H22.701C22.867 23.954 23.001 23.819 23.001 23.654V22.75C23.001 22.584 22.867 22.45 22.701 22.45H19.267Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2084 11.3182C14.6354 11.3182 14.1694 11.7842 14.1694 12.3562C14.1694 12.9292 14.6354 13.3952 15.2084 13.3952C15.7814 13.3952 16.2464 12.9292 16.2464 12.3562C16.2464 11.7842 15.7814 11.3182 15.2084 11.3182Z",
  fill: "black"
});

function SvgDoorClosed(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorClosed);
export default __webpack_public_path__ + "static/media/door-closed.2ad37077.svg";
export { ForwardRef as ReactComponent };